import { Outlet } from 'react-router-dom';
import { MeProvider } from './MeProvider';

/** Layout route: every screen below it has a resolved `/v1/me` session. */
export function MeGate() {
  return (
    <MeProvider>
      <Outlet />
    </MeProvider>
  );
}

export { isUnlockedRoute, LockedScreen } from './LockedScreen';
